import { Message } from "@/common/types/Message";
import { ActionTree, GetterTree, ModuleTree, MutationTree } from "vuex";

export type MessageStore = {
  messageState: Message
}

type RootState = {};

let messageState = { text: '', timestamp: Date.now(), state: '' } as Message;

const state: MessageStore = {
  messageState
};

const getters: GetterTree<MessageStore, RootState> = {
  MESSAGE: (store: MessageStore) => store.messageState,
  MESSAGETEXT: (store: MessageStore) => store.messageState.text,
  TIMESTAMP: (store: MessageStore) => store.messageState.timestamp,
  COLOR: (store: MessageStore) => store.messageState.state
};

const actions: ActionTree<MessageStore, RootState> = {
};

const mutations: MutationTree<MessageStore> = {
  INFO: (store: MessageStore, messageText: string) => {
    store.messageState = {
      state: 'info',
      timestamp: Date.now(),
      text: messageText
    };
  },
  ERROR: (store: MessageStore, messageText: string) => {
    store.messageState = {
      state: 'error',
      timestamp: Date.now(),
      text: messageText
    };
  },
  SUCCESS: (store: MessageStore, messageText: string) => {
    store.messageState = {
      state: 'success',
      timestamp: Date.now(),
      text: messageText
    };
  },
  WARNING: (store: MessageStore, messageText: string) => {
    store.messageState = {
      state: 'warning',
      timestamp: Date.now(),
      text: messageText
    };
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
} as ModuleTree<MessageStore>;
